import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function AgentSkillRestriction({ data }) {
    const skillRestriction = data?.skillsRestriction ?? {};
    const [gridApi, setGridApi] = useState(null);

    const skillRestrictionMap = {
        SUITABLE: "Aptidão",
        RESTRICTION: "Restrição",
    }

    const columnDefs = useMemo(() => ([
        { headerName: "Tipo", field: "type", flex: 1, valueFormatter: ({value}) => skillRestrictionMap[value] },
        { headerName: "Descrição", field: "description", flex: 1 }
    ]), [skillRestriction])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] mb-2">
                Aptidões e restrições
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={skillRestriction ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    formatters={{type: (row) => skillRestrictionMap[row.type]}}
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}